export default __webpack_public_path__ + "static/icon-58ebe2dbdaadc49f79191daf708228c4.png";